export enum Umsatzart {
  InnergemeinschaftlicheLieferung = 'INNERGEMEINSCHAFTLICHE_LIEFERUNG',
}
